import React from "react";
import { Route, Redirect } from "react-router-dom";
import { warn } from "../utils/logger";

// State
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { saveDesiredPage } from "../state/actions/userActions";

const PrivateRoute = ({ isAuthenticated, loading, token, saveDesiredPage, ...rest }) => {
  // If user is not authenticated once loading finishes, redirect to sign-in page
  if (!isAuthenticated && !loading) {
    warn(`[i] Unauthenticated user visited url[${window.location.pathname}]`);
    saveDesiredPage(); // Store desired page to session storage
    return <Route {...rest} render={(props) => <Redirect to="/auth/sign-in" {...props} />} />;
  }

  // User is authenticated, show route
  return <Route {...rest} />;
};

PrivateRoute.propTypes = {
  loading: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  token: state.user.token,
  loading: state.user.loading,
  isAuthenticated: state.user.isAuthenticated,
});

export default connect(mapStateToProps, { saveDesiredPage })(PrivateRoute);
